<template>
  <div>
    <h1>Add New Journal Entry</h1>
    <random-prompt></random-prompt> <!-- Include the random prompt component -->
    <form @submit.prevent="addEntry">
      <input v-model="title" placeholder="Title" />
      <textarea v-model="content" placeholder="Content"></textarea>
      <label>
        <input type="checkbox" v-model="isFavorite">
        Favorite
      </label>
      <button type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { db } from '../firebase-config';
import { collection, addDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import RandomPrompt from './RandomPrompt.vue'; // Import the RandomPrompt component

export default {
  components: {
    RandomPrompt // Register the RandomPrompt component
  },
  setup() {
    const title = ref('');
    const content = ref('');
    const isFavorite = ref(false);
    const auth = getAuth(); // Get auth instance

    const addEntry = async () => {
      const user = auth.currentUser; // Get the current user
      if (!user) {
        alert('You must be logged in to add entries.');
        return;
      }
      if (!title.value || !content.value) {
        alert('Both title and content are required');
        return;
      }

      try {
        await addDoc(collection(db, "journalEntries"), {
          title: title.value,
          content: content.value,
          userId: user.uid, // Include user ID with the entry
          date: new Date(),
          favorite: isFavorite.value
        });
        title.value = '';
        content.value = '';
        isFavorite.value = false;
        alert('Entry added!');
      } catch (error) {
        console.error("Error adding document: ", error);
        alert('Failed to add entry');
      }
    };

    return {
      title,
      content,
      isFavorite,
      addEntry
    };
  }
};
</script>

<style scoped>
div {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  background: #fff;
  border-radius: 8px;
}

h1 {
  text-align: center;
  color: #333;
}

input[type="text"], textarea {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  margin-bottom: 10px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
}

textarea {
  height: 150px; /* Larger text area for content */
}

input[type="checkbox"] {
  margin-right: 5px;
}

button {
  background-color: #5C67F2;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;
}

button:hover {
  background-color: #4a54f1;
  transition: background-color 0.3s;
}

.error {
  color: red;
  text-align: center;
}
</style>

